import { Injectable, DependencyLifeTime } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../contexts/DependencyContext";
import { GetComponentInfoWithStatusParameters } from "./http/component/models/GetComponentInfoWithStatusParameters";
import { ComponentListService } from "./http/component/ComponentListService";
import { Component } from "./http/component/models/Component";
import { IComponentInfoResult } from "./http/component/models/IComponentInfoResult";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class ComponentModelService
{
    private _componentModel: IComponentInfoResult;

    get componentModel(): IComponentInfoResult { return this._componentModel; }

    constructor(private readonly componentListService: ComponentListService)
    {
        this._componentModel = {
            rootComponent: this.createEmptyComponent(),
            rootComponentChildren: [],
            component: this.createEmptyComponent(),
            parents: [],
            children: [],
            dashboards: [],
            widgets: [],
            properties: []
        };
    }

    async loadComponentModel(id: string, timeMachineDate: Date): Promise<IComponentInfoResult>
    {
        const parameters = new GetComponentInfoWithStatusParameters();
        parameters.componentId = id || "root";
        parameters.date = timeMachineDate;

        this._componentModel = await this.componentListService.getComponentInfoWithIndicators(parameters);
        return this._componentModel;
    }

    private createEmptyComponent(): Component
    {
        const component = new Component();
        component.name = "Loading...";
        component.parentName = "Loading...";
        component.healthIndicatorStatusId = 4;
        component.healthIndicatorScore = 0;
        component.healthIndicatorName = "Risk Index";

        return component;
    }
}